import {Injectable, OnDestroy} from '@angular/core';
import {HubConnection, HubConnectionBuilder} from '@microsoft/signalr';
import {WebsocketConnectionException} from '../../models/exception/WebsocketConnectionException';

@Injectable({
    providedIn: 'root'
})
export abstract class BaseHubService implements OnDestroy {
    protected hubConnection?: HubConnection;

    public async initializeHubConnection() {
        try {
            if (this.hubConnection)
                return;

            const url: string = this.getUrl();
            this.hubConnection = new HubConnectionBuilder()
                .withUrl(url)
                .withAutomaticReconnect()
                .build();

            await this.hubConnection.start();
            this.registerListeners();
        } catch (error) {
            throw new WebsocketConnectionException();
        }
    }

    public async stopHubConnection() {
        await this.hubConnection?.stop();
        this.hubConnection = undefined;
    }

    public async ngOnDestroy() {
        await this.stopHubConnection();
    }

    protected abstract getUrl(): string;
    protected abstract registerListeners(): void;
}
